import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, ShoppingCart } from "lucide-react";

function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 w-full bg-white shadow-md z-50" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Mobile Menu Button - LEFT SIDE */}
          <button 
            className="md:hidden p-2 order-first" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          {/* Logo - CENTER ON MOBILE, LEFT ON DESKTOP */}
          <Link to="/" className="flex items-center space-x-3 mx-auto md:mx-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_vibrant-faith/artifacts/s6i02xam_IMG_7256_Original.jpg" 
              alt="Calvin D. Butts Inc. Logo" 
              className="h-16 w-auto"
              data-testid="site-logo"
            />
            <div className="hidden md:block">
              <div className="font-bold text-lg text-[#17181B]">Calvin D. Butts Inc.</div>
              <div className="text-xs text-gray-600">Empowering Youth, Building Futures</div>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`font-medium transition-colors ${
                isActive('/') ? 'text-[#1167B1] font-bold' : 'text-gray-700 hover:text-[#1167B1]'
              }`}
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link 
              to="/programs" 
              className={`font-medium transition-colors ${
                isActive('/programs') ? 'text-[#1167B1] font-bold' : 'text-gray-700 hover:text-[#1167B1]'
              }`}
              data-testid="nav-programs"
            >
              Programs
            </Link>
            <Link 
              to="/gallery" 
              className={`font-medium transition-colors ${
                isActive('/gallery') ? 'text-[#1167B1] font-bold' : 'text-gray-700 hover:text-[#1167B1]'
              }`}
              data-testid="nav-gallery"
            >
              Gallery
            </Link>
            <Link 
              to="/partners" 
              className={`font-medium transition-colors ${
                isActive('/partners') ? 'text-[#1167B1] font-bold' : 'text-gray-700 hover:text-[#1167B1]'
              }`}
              data-testid="nav-partners"
            >
              Partners
            </Link>
            <Link 
              to="/shop" 
              className={`font-medium transition-colors ${
                isActive('/shop') ? 'text-[#1167B1] font-bold' : 'text-gray-700 hover:text-[#1167B1]'
              }`}
              data-testid="nav-shop"
            >
              Shop
            </Link>
            <Link 
              to="/contact" 
              className={`font-medium transition-colors ${
                isActive('/contact') ? 'text-[#1167B1] font-bold' : 'text-gray-700 hover:text-[#1167B1]'
              }`}
              data-testid="nav-contact"
            >
              Contact
            </Link>
            <Link to="/donate">
              <Button 
                className="bg-[#FFE102] text-[#17181B] hover:bg-[#FFE102]/90 font-bold px-6 py-2 rounded-full shadow-lg"
                data-testid="nav-donate-button"
              >
                DONATE NOW
              </Button>
            </Link>
          </div>

          {/* Cart Icon - RIGHT SIDE (decorative) */}
          <div className="p-2" data-testid="cart-icon">
            <div className="relative">
              <ShoppingCart className="w-6 h-6 text-[#17181B]" />
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 space-y-3" data-testid="mobile-menu">
            <Link 
              to="/" 
              onClick={() => setMobileMenuOpen(false)} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Home
            </Link>
            <Link 
              to="/programs" 
              onClick={() => setMobileMenuOpen(false)} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Programs
            </Link>
            <Link 
              to="/gallery" 
              onClick={() => setMobileMenuOpen(false)} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Gallery
            </Link>
            <Link 
              to="/partners" 
              onClick={() => setMobileMenuOpen(false)} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Partners
            </Link>
            <Link 
              to="/shop" 
              onClick={() => setMobileMenuOpen(false)} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Shop
            </Link>
            <Link 
              to="/contact" 
              onClick={() => setMobileMenuOpen(false)} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
            >
              Contact
            </Link>
            <Link to="/donate" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-[#FFE102] text-[#17181B] hover:bg-[#FFE102]/90 font-bold">
                DONATE NOW
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navigation;